import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

// This is temporary until we switch over from FEV1 to V2 and can complete the route naming change to set-password.
export const Route = createFileRoute('/user/verify')({
  validateSearch: z.object({
    email: z.string().optional().catch(''),
    token: z.string().optional().catch('')
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/user/set-password',
      search: { email: search.email, token: search.token }
    })
  }
})
